export default __webpack_public_path__ + "static/media/eb-blk-2.59048b9e.png";